import {
  createRibbon as publicCreateRibbon,
  getRibbon as publicGetRibbon,
  updateRibbon as publicUpdateRibbon,
  deleteRibbon as publicDeleteRibbon,
  queryRibbons as publicQueryRibbons,
  typedQueryRibbons as publicTypedQueryRibbons,
  bulkCreateRibbons as publicBulkCreateRibbons,
  bulkUpdateRibbons as publicBulkUpdateRibbons,
  getOrCreateRibbon as publicGetOrCreateRibbon,
  bulkGetOrCreateRibbons as publicBulkGetOrCreateRibbons,
  bulkDeleteRibbons as publicBulkDeleteRibbons,
} from './stores-catalog-v3-ribbon-ribbons-v-3.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  QueryRibbonsOptions,
  RibbonQuery,
  RibbonsQueryBuilder,
  typedQueryRibbons as universalTypedQueryRibbons,
} from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';
import { onRibbonCreated as publicOnRibbonCreated } from './stores-catalog-v3-ribbon-ribbons-v-3.public.js';
import { onRibbonDeleted as publicOnRibbonDeleted } from './stores-catalog-v3-ribbon-ribbons-v-3.public.js';
import { onRibbonUpdated as publicOnRibbonUpdated } from './stores-catalog-v3-ribbon-ribbons-v-3.public.js';

function customQueryRibbons(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: (options?: QueryRibbonsOptions) =>
      publicQueryRibbons(httpClient)(options),
    typedQueryFunction: (query: RibbonQuery, options?: QueryRibbonsOptions) =>
      publicTypedQueryRibbons(httpClient)(query, options),
    hasOptionsParameter: true,
  });

  function overloadedQuery(
    query: RibbonQuery,
    options?: QueryRibbonsOptions
  ): ReturnType<typeof universalTypedQueryRibbons>;
  function overloadedQuery(options?: QueryRibbonsOptions): RibbonsQueryBuilder;
  function overloadedQuery(
    queryOrOptions?: RibbonQuery | QueryRibbonsOptions,
    options?: QueryRibbonsOptions
  ): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createRibbon: MaybeContext<
  BuildRESTFunction<typeof publicCreateRibbon> & typeof publicCreateRibbon
> = /*#__PURE__*/ createRESTModule(publicCreateRibbon);
export const getRibbon: MaybeContext<
  BuildRESTFunction<typeof publicGetRibbon> & typeof publicGetRibbon
> = /*#__PURE__*/ createRESTModule(publicGetRibbon);
export const updateRibbon: MaybeContext<
  BuildRESTFunction<typeof publicUpdateRibbon> & typeof publicUpdateRibbon
> = /*#__PURE__*/ createRESTModule(publicUpdateRibbon);
export const deleteRibbon: MaybeContext<
  BuildRESTFunction<typeof publicDeleteRibbon> & typeof publicDeleteRibbon
> = /*#__PURE__*/ createRESTModule(publicDeleteRibbon);
export const bulkCreateRibbons: MaybeContext<
  BuildRESTFunction<typeof publicBulkCreateRibbons> &
    typeof publicBulkCreateRibbons
> = /*#__PURE__*/ createRESTModule(publicBulkCreateRibbons);
export const bulkUpdateRibbons: MaybeContext<
  BuildRESTFunction<typeof publicBulkUpdateRibbons> &
    typeof publicBulkUpdateRibbons
> = /*#__PURE__*/ createRESTModule(publicBulkUpdateRibbons);
export const getOrCreateRibbon: MaybeContext<
  BuildRESTFunction<typeof publicGetOrCreateRibbon> &
    typeof publicGetOrCreateRibbon
> = /*#__PURE__*/ createRESTModule(publicGetOrCreateRibbon);
export const bulkGetOrCreateRibbons: MaybeContext<
  BuildRESTFunction<typeof publicBulkGetOrCreateRibbons> &
    typeof publicBulkGetOrCreateRibbons
> = /*#__PURE__*/ createRESTModule(publicBulkGetOrCreateRibbons);
export const bulkDeleteRibbons: MaybeContext<
  BuildRESTFunction<typeof publicBulkDeleteRibbons> &
    typeof publicBulkDeleteRibbons
> = /*#__PURE__*/ createRESTModule(publicBulkDeleteRibbons);
export const queryRibbons: MaybeContext<
  BuildRESTFunction<typeof customQueryRibbons> & typeof customQueryRibbons
> = /*#__PURE__*/ createRESTModule(customQueryRibbons);
/** */
export const onRibbonCreated: BuildEventDefinition<
  typeof publicOnRibbonCreated
> &
  typeof publicOnRibbonCreated = createEventModule(publicOnRibbonCreated);
/** */
export const onRibbonDeleted: BuildEventDefinition<
  typeof publicOnRibbonDeleted
> &
  typeof publicOnRibbonDeleted = createEventModule(publicOnRibbonDeleted);
/** */
export const onRibbonUpdated: BuildEventDefinition<
  typeof publicOnRibbonUpdated
> &
  typeof publicOnRibbonUpdated = createEventModule(publicOnRibbonUpdated);

export {
  RequestedFields,
  SortOrder,
  WebhookIdentityType,
} from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';
export {
  Ribbon,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateRibbonRequest,
  CreateRibbonResponse,
  GetRibbonRequest,
  GetRibbonResponse,
  UpdateRibbonRequest,
  UpdateRibbonResponse,
  DeleteRibbonRequest,
  DeleteRibbonResponse,
  QueryRibbonsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryRibbonsResponse,
  CursorPagingMetadata,
  Cursors,
  BulkCreateRibbonsRequest,
  BulkCreateRibbonsResponse,
  V3BulkRibbonResult,
  ItemMetadata,
  ApplicationError,
  BulkActionMetadata,
  BulkUpdateRibbonsRequest,
  MaskedRibbon,
  BulkUpdateRibbonsResponse,
  GetOrCreateRibbonRequest,
  GetOrCreateRibbonResponse,
  BulkGetOrCreateRibbonsRequest,
  BulkGetOrCreateRibbonsResponse,
  BulkGetOrCreateRibbonsForMigrationRequest,
  BulkGetOrCreateRibbonsForMigrationResponse,
  BulkDeleteRibbonsRequest,
  BulkDeleteRibbonsResponse,
  BulkRibbonResult,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  RecloneSiteRequest,
  RecloneSiteResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  RibbonCreatedEnvelope,
  RibbonDeletedEnvelope,
  RibbonUpdatedEnvelope,
  GetRibbonOptions,
  UpdateRibbon,
  UpdateRibbonOptions,
  QueryRibbonsOptions,
  RibbonsQueryResult,
  RibbonsQueryBuilder,
  RibbonQuerySpec,
  BulkCreateRibbonsOptions,
  BulkUpdateRibbonsOptions,
  GetOrCreateRibbonOptions,
  BulkGetOrCreateRibbonsOptions,
} from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';
export { utils } from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';
export {
  RequestedFieldsWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  RibbonQuery,
} from './stores-catalog-v3-ribbon-ribbons-v-3.universal.js';
